.pendingUpdatesContainer {
  position: fixed;
  bottom: 0;
  width: 100%;
  padding: 10px 15px;
  z-index: 10;
}
